import { InputLabel, styled } from '@mui/material';

const AdditionalControlsInputLabel = styled(InputLabel)({
  fontSize: 18,
});

export default AdditionalControlsInputLabel;
